export default {
  dialogText: {
    width: '300px',
    height: '30px'
  }
};
